import styled from "@emotion/styled";
import { Box, Theme, Typography } from "@mui/material";

export const Grid = styled(Box)<{theme: Theme}>((props) => ({
    marginRight: props.theme.spacing(10),
    marginLeft: props.theme.spacing(10),
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    backgroundColor: "#dbdbdb",
    gap: "1px",
}));

export const ListService = styled(Box)<{ theme: Theme }>(({ theme }) => ({
    marginRight: theme.spacing(10),
    marginLeft: theme.spacing(10),
    display: 'grid',
    gridTemplateColumns: '1fr', // 👈 una sola columna
    backgroundColor: "#dbdbdb",
    gap: "1px",
}));

export const StyledBox = styled(Box)<{theme: Theme}>((props) => ({
    backgroundColor: "white",
    padding: props.theme.spacing(5),
    display: 'flex',
    alignItems: 'center',
}));

export const StyledTypography = styled(Typography)<{cursor?: string}>((props) => ({
    cursor: props.cursor || 'pointer',
}));
